import request from './request'
import config from '../config'

const baseUrl = config.api.host
// const baseUrl = config.api.host + '/ucloud-oa-admin'
// const baseUrl = ''

export default {
  // 登录
  baseUrl,
  // uploadUrl: baseUrl + '/fileservice/ucstarftp/UcstarFileUploadServlet?action=1',

  sendBusinessApplyCode: data => {
    return request({
      url: baseUrl + `/openapi/public/sendBusinessApplyCode`,
      method: 'get',
      params: data
    })
  },
  dealBusinessApply: data => {
    return request({
      url: baseUrl + `/openapi/public/dealBusinessApply`,
      method: 'post',
      data
    })
  },
  dealApplyPlatform: data => {
    return request({
      url: baseUrl + `/openapi/public/dealApplyPlatform`,
      method: 'post',
      data
    })
  },
  sendApplyPlatformCode: data => {
    return request({
      url: baseUrl + `/openapi/public/sendApplyPlatformCode`,
      method: 'get',
      params: data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js